module.exports = __webpack_public_path__ + "static/media/Courier New-01.5cbc2662.svg";